import { Link } from "react-router-dom";

interface BreadcrumbProps {
  items: { label: string; to?: string }[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑" className="flex items-center flex-wrap gap-1.5 text-sm text-foreground-500">
      <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-400" />
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-600 transition-colors">{item.label}</Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}